
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
// Style
import s from './Page.css';
import { api, staticpageUploadDir } from '../../config';

class Page extends React.Component {
  render() {
    const { data } = this.props;

    return (
          <>
            {
              data && data.pageBanner && <div
                className={s.backGroungImg}
                style={{ backgroundImage: `url(${api.apiEndpoint + staticpageUploadDir + data.pageBanner})` }}
              />
            }
            {
              data && <div className={s.cotainerWith}>
                <div className={s.staticContainer}>
                  <h1>{data.metaTitle}</h1>
                  <div
                    dangerouslySetInnerHTML={{ __html: data.content }}
                  />
                </div>
              </div>
            }
          </>
    );
  }
}

export default withStyles(s)(Page);
